import React, { useEffect, useState } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import { closeButtonStyle, Saveandadduser } from "../components/Propertyfile";
import { List_Checker, RoleandMapping, createTextFileApi, configdata, indicatorlist, userinfo, ListAllusers } from "../components/ApiProperty";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import formStyles from '../assets/css/gapsy-form.module.css';
import { Modal, Button } from 'react-bootstrap';

const GapsyUserConfig = () => {
    const [filteredUsers, setFilteredUsers] = useState([]);
    const navigate = useNavigate();
    const [showModalLdap, setShowModalLdap] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [checkerData, setCheckerData] = useState(null);
    const [showAllowUploadPopup, setShowAllowUploadPopup] = useState(false);
    const [pendingPayload, setPendingPayload] = useState(null); // store request for retry
    const [modalMessage3, setModalMessage3] = useState('');
    const [message, setMessage] = useState("");
    const [modalMessage, setModalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success', 'warning', or 'error'
    const [disableInputs, setDisableInputs] = useState(false);
    const [passwordGenerated, setPasswordGenerated] = useState(false);
    const [selectedLocationValues, setSelectedLocationValues] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    // const [departments, setDepartments] = useState([]); // Initialize as empty array
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [users, setUsers] = useState([]);
    const [formData, setFormData] = useState({
        searchUserId: "",
        userFirstName: ""
    });
    const [initialData, setInitialData] = useState({});
    const [selectedRole, setSelectedRole] = useState('');
    const [hierarchy, setHierarchy] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'userId', direction: 'asc' });
    const [error, setError] = useState("");
    const [selectedChecker, setSelectedChecker] = useState('');
    let csrfToken = sessionStorage.getItem("tokenizedSession");
    const [selectedConfig, setSelectedConfig] = useState("");
    const [selectedRiskIndicators, setSelectedRiskIndicators] = useState([]);
    const [indicatorMap, setIndicatorMap] = useState({});
    const [customParameter, setCustomParameter] = useState("");


    // useEffect(() => {
    //     setSelectedRiskIndicators([]);
    // }, [selectedConfig]);

    useEffect(() => {
        setSelectedRiskIndicators([]);
        setCustomParameter("");
    }, [selectedConfig]);

    const dept = sessionStorage.getItem("dept");

    useEffect(() => {
        const fetchIndicators = async () => {
            try {
                setIsLoading(true);
                const config = {
                    params: { "adminId": localStorage.getItem('userid'), dept: dept },
                    headers: {
                        'x-csrf-token': csrfToken,
                    },
                    withCredentials: true
                }
                const response = await axios.post(indicatorlist, {}, config);
                console.log("Indicatorlist API Response:", response.data);

                setIndicatorMap(response.data.data);

            } catch (error) {
                console.error("Error fetching Indicatorlist:", error);
                setIndicatorMap([]);
            }
        };
        fetchIndicators();
    }, []);


    const getIndicatorKey = (config) => {
        if (!config) return "";
        if (config === "Others") return "Critical";

        if (config === "Pillar1") return "Pillar1";
        if (config === "Pillar2") return "Pillar2";

        if (config.includes("Daily")) return "Daily";
        if (config.includes("Monthly")) return "Monthly";
        if (config.includes("Quarterly")) return "Quarterly";

        if (config === "Critical") return "Critical";

        return "";
    };

    const filteredIndicators = indicatorMap[getIndicatorKey(selectedConfig)] || [];

    const configNames = [
        "Pillar1",
        "Pillar2",
        "Top5-Daily",
        "Top5-Monthly",
        "Top5-Quarterly",
        "Watchlist-Daily",
        "Watchlist-Monthly",
        "Watchlist-Quarterly",
        "Critical",
        "Others"
    ];

    const handleCancelUpload = () => {
        setShowAllowUploadPopup(false);
        setPendingPayload(null);
    };

    const handleForceUpload = async () => {
        try {
            setShowAllowUploadPopup(false);
            setIsLoading(true);

            const responseDb = await submitLdapData('Y'); // second call

            if (responseDb.data?.status === 'success') {
                setMessageType('success');
                setModalMessage(responseDb.data?.message);
            } else {
                setMessageType('error');
                setModalMessage(responseDb.data?.message || "Update failed");
            }

        } catch (error) {
            console.error(error);
            setMessageType('error');
            setModalMessage('Error while updating');
        } finally {
            setIsLoading(false);
            setPendingPayload(null);
        }
    };

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                // setIsLoading(true);

                const config = {
                    params: {
                        adminId: localStorage.getItem('userid'),
                        tableName: "param_indicator"
                    },
                    headers: {
                        'x-csrf-token': csrfToken,
                    },
                    withCredentials: true
                };

                const response = await axios.post(RoleandMapping, {}, config);

                const apiData = (response.data.data || []).map(item => ({
                    parameterName: item.PARAMETER_NAME,
                    riskIndicator: item.RISK_INDICATOR
                }));

                setUsers(apiData);
                setFilteredUsers(apiData);

            } catch (error) {
                console.error('Error fetching users!', error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchUsers();
    }, []);


    const existingParams = users.map(u => u.parameterName.toLowerCase());

    const availableConfigs = configNames.filter(config => {
        if (config === "Others") return true;
        return !existingParams.includes(config.toLowerCase());
    });

    const submitLdapData = async (allowUpdate = '') => {
        const adminId = localStorage.getItem('userid') || '';

        // const normalizedConfig = selectedConfig.replace(/\s+/g, '');
        // console.log("Normalized config name:", normalizedConfig);

        // const jsonData = {
        //     configName: selectedConfig, // keep original for DB
        //     riskIndicators: selectedRiskIndicators
        // };

        const finalConfigName =
            selectedConfig === "Others" ? customParameter : selectedConfig;

        const normalizedConfig = finalConfigName.replace(/\s+/g, '');

        const jsonData = {
            configName: finalConfigName,   // ✅ FIXED
            riskIndicators: selectedRiskIndicators
        };

        const content = JSON.stringify(jsonData, null, 2);

        // ✅ USE normalized name everywhere
        const filename = `${normalizedConfig}_config.json`;
        console.log("Generated filename:", filename);

        // Step 1
        await axios.post(
            createTextFileApi,
            { filename, content },
            {
                headers: {
                    'Content-Type': 'application/json',
                    userId: adminId,
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true,
            }
        );

        // Step 2
        const config = {
            headers: {
                userId: adminId,
                "x-csrf-token": csrfToken
            },
            withCredentials: true,
            params: {
                filePath: `/saswork/nas/${filename}`, // ✅ now correct
                Notifications: "IN",
                dept: dept,
                configName: finalConfigName,
                allowUpdate: allowUpdate
            }
        };

        return await axios.post(configdata, {}, config);
    };

    const handleLdapSubmit = async (e) => {
        e.preventDefault();

        try {
            const adminId = localStorage.getItem('userid') || '';

            // Correct validation based on current UI
            if (!selectedConfig) {
                setMessageType('error');
                setModalMessage("Parameter is required");
                return;
            }

            if (selectedRiskIndicators.length === 0) {
                setMessageType('error');
                setModalMessage("Risk Indicators are required");
                return;
            }
            setIsLoading(true);

            const responseDb = await submitLdapData(); // first call

            if (responseDb.data?.status?.toLowerCase() === 'update') {

                // 🔥 store state for retry
                setPendingPayload(true);

                setModalMessage3(`
                ${selectedConfig}:
                Existing Risk Indicators: ${responseDb.data.existingRiskIndicator}<br/>
                Do you want to update?
            `);

                setShowAllowUploadPopup(true);
                return;
            }

            if (responseDb.data?.status === 'success') {
                setMessageType('success');
                setModalMessage(responseDb.data?.message);
            } else {
                setMessageType('error');
                setModalMessage(responseDb.data?.message || "Failed");
            }

        } catch (error) {
            console.error(error);
            setMessageType('error');
            setModalMessage('Error while processing request');
        } finally {
            setIsLoading(false);
        }
    };


    const handleClear = () => {
        setShowModalLdap(false);

        setFormData({
            searchUserId: "",
            userFirstName: "",
            userRole: "",
            orgHierarchy: ""
        });

        setSelectedConfig("");
        setSelectedRiskIndicators([]);

        setInitialData({});
        setEditIndex(null);
        setMessage('');
    };

    const handleCloseLdap = () => {

        if (messageType === 'error') {
            setModalMessage('');
            return;
        }

        setShowModalLdap(false);

        setFormData({
            searchUserId: "",
            userFirstName: "",
            userRole: "",
            orgHierarchy: ""
        });

        setModalMessage('');
        // (correct states)
        setSelectedConfig("");
        setSelectedRiskIndicators([]);

        setInitialData({});
        setEditIndex(null);
        setMessage('');
    };

    const handleDashboard = (e) => {
        e.preventDefault();
        navigate('/gapsyAdashboard');
        // Additional logic if needed
    };

    const handleRaf = (e) => {
        e.preventDefault();
        navigate('/gapsyparametermapping');
        // Additional logic if needed
    };

    const handleCloseModal = () => {
        setModalMessage('');
    };

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item ${styles.breadcrumbItem}`} style={{ cursor: "pointer" }} aria-current="page">
                                    <a onClick={handleRaf} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-person-plus me-2" ></i>RAF - Reports Parameters
                                    </a>
                                </li>
                                {/* <li className={`breadcrumb-item ${styles.breadcrumbItem}`} aria-current="page">
                                    <i onClick={handleRaf} className="bi bi-person-plus me-2"></i>RAF - User - Role Mapping
                                </li> */}
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-person-plus me-2"></i>RAF - Add New Parameters
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className='row'>
                                    <div className="col justify-content-center">
                                        <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                            <div className="card-body">
                                                <div className="mb-0">
                                                    <h6 className={`pb-1 mb-3 ${styles.borderBottom}`}>RAF - Add New Parameters</h6>
                                                    <div className="d-flex justify-content-center">
                                                        <div className="w-100" style={{ maxWidth: '700px' }}>
                                                            <div className={`mx-auto ${formStyles.formWrapper}`}>

                                                                <form className="form px-6" onSubmit={handleLdapSubmit}>

                                                                    <input type="hidden" name="adminId" value={localStorage.getItem('userid')} readOnly />

                                                                    {/* USER ID */}

                                                                    <div className="form-group row mb-2">
                                                                        <label className="col-sm-3 col-form-label label-black">
                                                                            Select The Parameter
                                                                        </label>

                                                                        <div className="col-sm-8">
                                                                            <select
                                                                                className="form-control form-control-sm"
                                                                                value={selectedConfig}
                                                                                onChange={(e) => setSelectedConfig(e.target.value)}
                                                                            >
                                                                                <option value="">Select The Parameter</option>

                                                                                {availableConfigs.map((config, index) => (
                                                                                    <option key={index} value={config}>
                                                                                        {config}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    {selectedConfig === "Others" && (
                                                                        <div className="form-group row mb-2">
                                                                            <label className="col-sm-3 col-form-label label-black">
                                                                                Enter Parameter Name
                                                                            </label>

                                                                            <div className="col-sm-8">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control form-control-sm"
                                                                                    value={customParameter}
                                                                                    onChange={(e) => setCustomParameter(e.target.value)}
                                                                                    placeholder="Enter parameter name"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {/* USER NAME */}

                                                                    <div className="form-group row mb-2">
                                                                        <label className="col-sm-3 col-form-label label-black">
                                                                            Select Risk Indicator
                                                                        </label>

                                                                        <div className="col-sm-8">
                                                                            <div className="dropdown">
                                                                                <button
                                                                                    className="btn btn-light btn-sm dropdown-toggle w-100 text-start text-truncate"
                                                                                    type="button"
                                                                                    data-bs-toggle="dropdown"
                                                                                    style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                                                                                >
                                                                                    {selectedRiskIndicators.length > 0
                                                                                        ? selectedRiskIndicators.join(", ")
                                                                                        : "Select Risk Indicator"}
                                                                                </button>
                                                                                <ul
                                                                                    className="dropdown-menu w-100"
                                                                                    style={{ maxHeight: "200px", overflowY: "auto" }}
                                                                                >
                                                                                    {filteredIndicators.map((indicator, index) => (
                                                                                        <li key={index} className="px-2">
                                                                                            <div className="form-check">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    className="form-check-input"
                                                                                                    checked={selectedRiskIndicators.includes(indicator)}
                                                                                                    onChange={(e) => {

                                                                                                        const top5Configs = ["Top5-Daily", "Top5-Monthly", "Top5-Quarterly"];
                                                                                                        const maxLimit = top5Configs.includes(selectedConfig) ? 5 : 7;

                                                                                                        if (e.target.checked) {

                                                                                                            if (selectedRiskIndicators.length >= maxLimit) {
                                                                                                                setMessageType('error');
                                                                                                                setModalMessage(`Maximum ${maxLimit} Risk Indicators allowed`);
                                                                                                                return;
                                                                                                            }

                                                                                                            setSelectedRiskIndicators([
                                                                                                                ...selectedRiskIndicators,
                                                                                                                indicator
                                                                                                            ]);

                                                                                                        } else {
                                                                                                            setSelectedRiskIndicators(
                                                                                                                selectedRiskIndicators.filter(i => i !== indicator)
                                                                                                            );
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                                <label className="form-check-label">
                                                                                                    {indicator}
                                                                                                </label>
                                                                                            </div>
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                    {/* BUTTONS */}

                                                                    <div className="form-group row mt-2">

                                                                        <div className="col-sm-4"></div>

                                                                        <div className="col-sm-7 d-flex">

                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-secondary me-2"
                                                                                onClick={handleClear}
                                                                                style={closeButtonStyle}
                                                                            >
                                                                                Clear
                                                                            </button>

                                                                            <button
                                                                                type="submit"
                                                                                className="btn btn-sm btn-primary"
                                                                                style={Saveandadduser}
                                                                                disabled={disableInputs}
                                                                            >
                                                                                Submit
                                                                            </button>

                                                                        </div>

                                                                    </div>

                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {showAllowUploadPopup && (
                                            <Modal show onHide={handleCancelUpload} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                                <Modal.Header style={{ backgroundColor: '#366872', color: 'white', padding: '0.5rem 1rem' }}>
                                                    <Modal.Title style={{ fontSize: '16px' }}>Confirmation</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}
                                                    /* <sttong>{toTitleCase(editableTableName)}</sttong> Template is already exists. Do you wish to upload data with the same template? */
                                                    dangerouslySetInnerHTML={{
                                                        __html: modalMessage3.replace(/\n/g, '<br />')
                                                    }}>
                                                </Modal.Body>
                                                <Modal.Footer style={{ borderTop: 'none' }}>
                                                    <Button variant="secondary" onClick={handleCancelUpload}>No</Button>
                                                    <Button variant="primary" onClick={handleForceUpload}>Yes</Button>
                                                </Modal.Footer>
                                            </Modal>
                                        )}

                                        {/* Modal for messages */}
                                        <Modal
                                            show={!!modalMessage}
                                            onHide={handleCloseModal}
                                            backdrop="static"
                                            keyboard={false}
                                            style={{ marginTop: '12vh' }}
                                        >
                                            <div
                                                className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                                                role="alert"
                                                style={{ marginBottom: '0' }}
                                            >
                                                <div className="d-flex align-items-center">
                                                    {messageType === 'success' ? (
                                                        <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
                                                    ) : messageType === 'warning' ? (
                                                        <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
                                                    ) : (
                                                        <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
                                                    )}
                                                    <p
                                                        style={{
                                                            display: 'inline',
                                                            marginBottom: '0px',
                                                            color: messageType === 'success'
                                                                ? 'green'
                                                                : messageType === 'warning'
                                                                    ? '#ffc107'
                                                                    : 'red'
                                                        }}
                                                    >
                                                        {modalMessage}
                                                    </p>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={handleCloseLdap}
                                                    style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }}
                                                />
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyUserConfig;
